import React, { useState } from 'react'
import { Typography, Form, Col, Input, Row, message } from 'antd'
import PhoneInput from 'react-phone-input-2'
import { MailOutlined } from '@ant-design/icons'
import axios from 'axios'
import useLocalStorage from '../utils/useLocalStorage'

message.config({
  top: 100,
  duration: 3,
  maxCount: 3
})

const Telefono = (props) => {
  const { telefono = '' } = props.formValue
  const [numeroTelefono, setNumeroTelefono] = useState({
    phone_no: telefono,
    status: new RegExp(/[0-9]{9,10}/).test(telefono)
  })
  const [code, setCode] = useState(undefined)
  const onSendSMS = async () => {
    try {
      const { data: result } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/sendmobilecode`,
        {
          terms: false,
          phone_no: numeroTelefono.tel,
          country_code: numeroTelefono.dialCode
        },
        {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      setNumeroTelefono({
        ...numeroTelefono,
        status: false
      })
      message.success('Codice mandato con successo')
    } catch (e) {
      setNumeroTelefono({
        ...numeroTelefono,
        status:
          process.env.REACT_APP_NODE_ENV === 'development' ? false : undefined
      })
      message.error("Errore nell'invio del codice di verifica")
    }
  }
  const onVerificationCode = async () => {
    try {
      const { data: { data: result } = {} } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/verifymobilecode`,
        {
          terms: false,
          phone_no: numeroTelefono.tel,
          country_code: numeroTelefono.dialCode,
          verify_code: code
        },
        {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      if (result.success) {
        setNumeroTelefono({
          ...numeroTelefono,
          status: true
        })
        props.incrementStep()
      } else {
        message.error(result.message)
      }
    } catch (e) {
      message.error('Errore nella verifica del numero')
    }
  }
  const handleOnChange = (value, data, event) => {
    const telephone = value.replace(/[^0-9]+/g, '').slice(data.dialCode.length).trim() || ''
    setNumeroTelefono({
      ...numeroTelefono,
      tel: telephone,
      dialCode: data.dialCode,
      status: new RegExp(/[0-9]{9,10}/).test(telephone)
    })
  }

  const saveNumber = async () => {
    try {
      const { data: result } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/savephone`,
        {
          terms: false,
          phone_no: numeroTelefono.dialCode + numeroTelefono.tel,
          country_code: numeroTelefono.dialCode
        },
        {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      setNumeroTelefono({
        ...numeroTelefono,
        status: false
      })
      props.incrementStep()
      // message.success('Codice mandato con successo')
    } catch (e) {
      setNumeroTelefono({
        ...numeroTelefono,
        status:
          process.env.REACT_APP_NODE_ENV === 'development' ? false : undefined
      })
      message.error('Errore nel salvataggio numero')
    }
  }

  const codeOnChange = (e) => {
    setCode(e.target.value)
  }
  return (
    <>
      <Typography.Title>
        Ti aiutiamo ad affittare il tuo appartamento
      </Typography.Title>
      <Row>
        <Col xs={24} sm={24} md={24} lg={18}>
          <p className='font-semibold text-gray-600 md:text-xl'>
            Con le tue informazioni di contatto, potremo farti sapere quando
            abbiamo nuove richieste ed aiutarti a gestire l'affitto del tuo
            appartamento
          </p>
        </Col>
      </Row>
      <Col xs={24} sm={24} md={24} lg={16}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item name='nome'>
              <Input placeholder='Nome e Cognome' />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name='telefono'
              rules={[{ required: true }]}
              getValueProps={(value) => value}
            >
              <PhoneInput
                country='it'
                onlyCountries={['it']}
                placeholder='Inserisci il numero di telefono'
                enableSearch
                value={
                  !props.formValue.telefono || props.formValue.telefono == '-'
                    ? undefined
                    : props.formValue.telefono
                }
                containerStyle={{
                  width: '100%'
                }}
                inputStyle={{
                  width: '100%'
                }}
                onChange={handleOnChange}
              />
            </Form.Item>
          </Col>
        </Row>
        {numeroTelefono.status === false &&
          process.env.REACT_APP_VERIFY_PHONE_DISABLED == 'false' && (
            <>
              <p className='font-semibold text-gray-600 md:text-xl'>
                Clicca su invia codice per inviare un SMS al numero inviato.
                Inserisci il codice di verifica inviato al tuo numero per
                proseguire
              </p>
              <Row gutter={[16, 16]}>
                <Col xs={10} sm={12} md={12} lg={6}>
                  <Input.Password onChange={codeOnChange} />
                </Col>
                <Col xs={14} sm={8} md={8} lg={10}>
                  <div
                    className='flex items-center justify-around h-full font-semibold cursor-pointer'
                    onClick={() => onSendSMS()}
                  >
                    <MailOutlined className='text-2xl' />
                    <span className='uppercase'>Invia nuovo codice</span>
                  </div>
                </Col>
              </Row>
              <button
                onClick={() => onVerificationCode()}
                type='button'
                className='bg-success-accent rounded-full py-4 px-16 text-xl mt-4 uppercase text-white'
              >
                Verifica Numero
              </button>
            </>
        )}

        {numeroTelefono.status === true &&
          process.env.REACT_APP_VERIFY_PHONE_DISABLED == 'false' && (
            <>
              <p className='font-semibold text-gray-600 md:text-xl text-success-accent'>
                Il numero di telefono è stato validato
              </p>
              <button
                onClick={() => props.incrementStep()}
                type='button'
                className='bg-primary rounded-full py-4 px-16 text-xl mt-4 uppercase text-white'
              >
                Prosegui
              </button>
            </>
        )}

        {(numeroTelefono.status === true || process.env.REACT_APP_VERIFY_PHONE_DISABLED == 'true') && (
            <>
              <button
                disabled={!numeroTelefono.status}
                onClick={() => saveNumber()}
                type='button'
                className={`bg-primary${numeroTelefono.status ? '' : '-light'} rounded-full py-4 px-16 text-xl mt-4 uppercase text-white`}
              >
                Prosegui
              </button>
            </>
        )}
      </Col>
    </>
  )
}

export default Telefono
